// start:ng42.barrel
import './mass-adjustment-group-detail.component';
import './mass-adjustment-group-filter.component';
import './mass-adjustment-group.component';
// end:ng42.barrel

